"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var _util_1 = require("../../_util");
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function ShortBanner(props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var content = props.content, backgroundUrl = props.backgroundUrl, contentColor = props.contentColor, className = props.className;
    var formatBackgroundUrl = (0, _util_1.fomateFileData)(backgroundUrl).url;
    var bgStyle = formatBackgroundUrl
        ? { background: "url(".concat(formatBackgroundUrl, ") center no-repeat"), backgroundSize: 'cover' }
        : {};
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-short-banner"), className), style: bgStyle },
        react_1.default.createElement("div", { className: "main" },
            react_1.default.createElement("div", { className: "content", style: { color: contentColor } }, content))));
}
exports.default = ShortBanner;
//# sourceMappingURL=ShortBanner.js.map